import { FormDataType } from "../TaskForm";

export function DefaultFormProps(user_email: string, user_name: string): FormDataType {
  // Format today's date as YYYY-MM-DD for the date input
  const today = new Date().toISOString().split("T")[0];

  return {
    title: "",
    description: "",
    completion_percentage: 0,
    due_date: today,
    project: null,
    assigned_to: {
      value: "",
      label: ""
    },
    assigned_by: {
      value: user_email,
      label: user_name
    },
    status: {
      value: "Active" as const,
      label: "Active"
    },
    category: {
      value: "Other",
      label: "Other"
    },
  };
}
